import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { AuthType } from '.';
import { RootStateType } from '../redux-store/reducers';
import React from 'react';

function RedirectRoute({ token, isLoggedIn, component: Component, path = '', ...rest }: AuthType) {
    const _window: any = window;
    const isAuthenticated = !!_window.cordova ? (!!rest.userId ? true : false) : !!isLoggedIn;
    // const _path:any = path;
    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated &&
                    !path.includes('/links') &&
                    !(path.includes('/stack') && isAuthenticated) ? (
                    <Redirect to="/portal" from={props.location.pathname} />
                ) : (
                    <Component {...props} />
                )
            }
        />
    );
}

export default connect(({ authReducer }: RootStateType) => {
    return {
        token: authReducer.token,
        isLoggedIn: authReducer.isLoggedIn,
        userId: authReducer.pan,
    };
}, {})(RedirectRoute);
